import { loadableWithRetry } from '../../common/utils/lazyLoad'
import EmptyCenteredFlexLayout from '@app/common/layout/EmptyCenteredFlexLayout'
import EmptyLoyout from '@common/layout/EmptyLoyout'

const routes = [
  {
    path: '/',
    exact: true,
    name: 'auth',
    layout: EmptyCenteredFlexLayout,
    publicRoute: true,
    redirectTo: 'auth/login',
  },
  {
    path: '/login',
    name: 'login',
    layout: EmptyCenteredFlexLayout,
    publicRoute: true,
    component: loadableWithRetry(() => import('./login/LoginContainer')),
  },
  {
    path: '/logout',
    name: 'logout',
    layout: EmptyCenteredFlexLayout,
    publicRoute: true,
    component: loadableWithRetry(() => import('./containers/LogoutContainer')),
  },
  {
    path: '/switch-account',
    name: 'switch-account',
    layout: EmptyCenteredFlexLayout,
    publicRoute: true,
    component: loadableWithRetry(() => import('./switch-account/SwitchAccountContainer')),
  },
  {
    path: '/forgot',
    name: 'forgot',
    layout: EmptyLoyout,
    publicRoute: true,
    component: loadableWithRetry(() => import('./containers/ForgotPasswordContainer')),
  },
  {
    path: '/reset',
    name: 'reset',
    layout: EmptyLoyout,
    publicRoute: true,
    component: loadableWithRetry(() => import('./containers/ResetPasswordContainer')),
  },
  {
    path: '/reset-success',
    name: 'reset-success',
    layout: EmptyLoyout,
    publicRoute: true,
    component: loadableWithRetry(() => import('./containers/ResetSuccessContainer')),
  },
  {
    path: '/sso-login',
    name: 'sso-login',
    layout: EmptyLoyout,
    publicRoute: true,
    component: loadableWithRetry(() => import('./containers/SSOLoginContainer')),
  },
  {
    path: '/sso-redirect',
    name: 'sso-redirect',
    publicRoute: true,
    layout: EmptyLoyout,
    component: loadableWithRetry(() => import('./components/LoginSSORedirect')),
  },
]

export default routes
